import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import {
  FaGithub,
  FaLinkedin,
  FaTwitter,
  FaCodepen,
  FaSun,
  FaMoon,
  FaHeart,
} from "react-icons/fa";
import "./Footer.css";

const Footer = () => {
  const [isDarkMode, setIsDarkMode] = useState(true);
  const [currentYear, setCurrentYear] = useState(new Date().getFullYear());

  useEffect(() => {
    document.documentElement.classList.toggle("dark-mode", isDarkMode);
    document.documentElement.classList.toggle("light-mode", !isDarkMode);
  }, [isDarkMode]);

  const socialLinks = [
    {
      icon: <FaGithub />,
      url: "https://github.com/DamianKingStanley",
      name: "GitHub",
    },
    {
      icon: <FaLinkedin />,
      url: "https://www.linkedin.com/in/damian-theking/",
      name: "LinkedIn",
    },
    {
      icon: <FaTwitter />,
      url: "https://x.com/_king_Damian?s=09",
      name: "Twitter",
    },
    {
      icon: <FaCodepen />,
      url: "https://codepen.io/yourprofile",
      name: "CodePen",
    },
  ];

  return (
    <motion.footer
      className="footer-container"
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.8, ease: "easeOut" }}
    >
      <div className="footer-content">
        {/* Left Section */}
        <motion.div className="footer-left" whileHover={{ scale: 1.02 }}>
          <p className="copyright">
            &copy; {currentYear} Damian King Stanley. All rights reserved.
          </p>
          <p className="made-with">
            Made with <FaHeart className="heart-icon" /> using React
          </p>
        </motion.div>

        {/* Middle Section */}
        <div className="footer-middle">
          <motion.div
            className="theme-toggle"
            onClick={() => setIsDarkMode(!isDarkMode)}
            whileTap={{ scale: 0.9 }}
          >
            {isDarkMode ? (
              <FaSun className="theme-icon" />
            ) : (
              <FaMoon className="theme-icon" />
            )}
          </motion.div>
        </div>

        {/* Right Section */}
        <div className="footer-right">
          <div className="social-links">
            {socialLinks.map((link, index) => (
              <motion.a
                key={index}
                href={link.url}
                target="_blank"
                rel="noopener noreferrer"
                className="social-link"
                whileHover={{
                  y: -5,
                  color: isDarkMode ? "#1DA1F2" : "#794BC4",
                }}
                aria-label={link.name}
              >
                {link.icon}
              </motion.a>
            ))}
          </div>
          <motion.div className="portfolio-link" whileHover={{ scale: 1.05 }}>
            <Link
              to="https://kingdamian.netlify.app/"
              target="_blank"
              rel="noopener noreferrer"
            >
              View Full Portfolio
            </Link>
          </motion.div>
        </div>
      </div>

      {/* Decorative Elements */}
      <div className="footer-decoration">
        <div className="footer-wave"></div>
        <div className="footer-dots">
          {[...Array(20)].map((_, i) => (
            <div key={i} className="dot"></div>
          ))}
        </div>
      </div>
    </motion.footer>
  );
};

export default Footer;
